module.exports = __webpack_public_path__ + "static/media/appleIcon.e2d7813e.svg";